import React from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route
} from 'react-router-dom';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import './App.css';
import HomePage from './components/HomePage';
import CategoryPage from './components/CategoryPage';
import CategoriesListPage from './components/CategoriesListPage';
import ContentDetailPage from './components/ContentDetailPage';
import SearchResultsPage from './components/SearchResultsPage';
import TagResultsPage from './components/TagResultsPage'; 

// Default site metadata (can be overridden by individual pages)
const defaultTitle = "无聊百科 - 有点意思但不多";
const defaultDescription = "探索各种冷知识、怪问题、脑洞和生活中的奇闻趣事。每天发现一点新奇，让生活更有趣。";
const siteUrl = "https://wlbk.aolifu.org"; 

function App() {
  return (
    <HelmetProvider>
      <Router>
        {/* Default Helmet tags for all pages - can be overridden */}
        <Helmet>
          <html lang="zh-CN" />
          <title>{defaultTitle}</title>
          <meta name="description" content={defaultDescription} />
          <link rel="canonical" href={siteUrl} />
          {/* Open Graph / Facebook */}
          <meta property="og:type" content="website" />
          <meta property="og:url" content={siteUrl} />
          <meta property="og:title" content={defaultTitle} />
          <meta property="og:description" content={defaultDescription} />
          <meta property="og:image" content={`${siteUrl}/logo512.png`} />
          <meta property="og:site_name" content="无聊百科" />
          <meta property="og:locale" content="zh_CN" />
          {/* Twitter Card */}
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:url" content={siteUrl} />
          <meta name="twitter:title" content={defaultTitle} />
          <meta name="twitter:description" content={defaultDescription} />
          <meta name="twitter:image" content={`${siteUrl}/logo512.png`} />
        </Helmet>
        <div className="App">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/search" element={<SearchResultsPage />} /> 
            <Route path="/tags/:tagName" element={<TagResultsPage />} /> 
            <Route path="/categories/:categoryName/:itemId" element={<ContentDetailPage />} /> 
            <Route path="/categories/:categoryName" element={<CategoryPage />} />
            <Route path="/categories" element={<CategoriesListPage />} /> 
          </Routes>
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
